import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/menu/categories/46-moto-casual-camisetas.svg")